import React from "react";
import SkeletonLoader from "../SkeletonLoader";
import AuditableInfo from "../AuditableInfo";

interface CommonHistory {
    id: string;
    comment: string;
    sortOrder: number;
}

interface CommonHistoryFormProps {
    data: CommonHistory[];
    title: string;
    count: number;
    hasAddPermission: boolean;
    hasSortPermission: boolean;
    loading?: any
    error?: any,
}

const CommonHistoryForm: React.FC<CommonHistoryFormProps> = ({
    data,
    loading,
    error,
    title
}) => {
    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">{title} ({data?.length || 0})</h5>
            </div>
            <div className={'p-2'}>
                <div className='overflow-y-auto max-h-96'>
                    {
                        (loading) ?
                            <SkeletonLoader className={"mt-2"} count={3}></SkeletonLoader> :
                            !error && data?.length === 0 ?
                                <div className="mt-1 border-2 border-surface-5 bg-text-0 p-2 rounded-sm">
                                    <h3>
                                        No history to display
                                    </h3>
                                </div>
                                :
                                !error && data?.map((d: any) => {
                                    return <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0">
                                        <div className="grid-cols-12 lg:grid sm:block">
                                            <div className="col-span-6 ">
                                                <div className="flex gap-2">
                                                    {d?.dataFileType &&
                                                        <div
                                                            className="text-text-0 bg-highlight-4
                                                    p-1  text-[8px] font-bold leading-none
                                                    rounded"
                                                        >{d?.dataFileType}</div>
                                                    }
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="flex gap-2 items-center">
                                                        <h3 className="text-surface-3 break-words w-[30ch]">
                                                            {d?.message}
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-span-6 text-sm text-end">
                                                <AuditableInfo data={d} />
                                            </div>
                                        </div>
                                    </div>
                                })
                    }
                </div>
            </div>

        </div>
    );
};

export default CommonHistoryForm;
